import { Box, Grid } from "@mui/material";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useIntl } from "react-intl";

const NotificationsPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    emailTemplatesUrl,
    emailThemeUrl,
    notificationConfigurationsUrl,
  } = useGlobalContext();

  useTitle(t({ id: "notifications" }));

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "notificationConfigurations" })}
            url={notificationConfigurationsUrl()}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard title={t({ id: "emailThemes" })} url={emailThemeUrl()} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <NavCard
            title={t({ id: "emailTemplates" })}
            url={emailTemplatesUrl()}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotificationsPage;
